import { Nullable } from 'utils/types';
import { EndowmentId } from '../api/cases/repaymentStrategy/endowment/Endowment';

export enum EndowmentField {
  Id = 'id',
  Provider = 'provider',
  ExpectedMaturityDate = 'expectedMaturityDate',
  CurrentFundValue = 'currentFundValue',
  MonthlyContribution = 'monthlyContribution',
}

export interface Endowment {
  [EndowmentField.Id]: EndowmentId;
  [EndowmentField.Provider]: Nullable<string>;
  [EndowmentField.ExpectedMaturityDate]: Nullable<string>;
  [EndowmentField.CurrentFundValue]: Nullable<number>;
  [EndowmentField.MonthlyContribution]: Nullable<number>;
}

export const createEmptyEndowment = (): Endowment => ({
  [EndowmentField.Id]: null,
  [EndowmentField.Provider]: null,
  [EndowmentField.ExpectedMaturityDate]: null,
  [EndowmentField.CurrentFundValue]: null,
  [EndowmentField.MonthlyContribution]: null,
});
